import { Button, UIHeading1, UIText1 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './styles.css';
import { NBSP } from '../../../constants/symbols';

interface IRentRaffle2024BannerProps {
  url: string;
  onClick: () => void;
}

export function RentRaffle2024Banner({ url, onClick }: IRentRaffle2024BannerProps) {
  return (
    <a
      href={`${url}?cian_source=listing_banner`}
      target="_blank"
      rel="noreferrer"
      onClick={onClick}
      className={styles['container']}
    >
      <div className={styles['wrapper']}>
        <UIHeading1>
          Аренда квартиры{NBSP}—{NBSP}бесплатно
        </UIHeading1>
        <UIText1>
          Звоните по{NBSP}объявлениям и{NBSP}выиграйте оплату аренды
        </UIText1>
        <Button size="L" theme="fill_primary">
          Узнать подробности
        </Button>
      </div>
    </a>
  );
}
